import { render, staticRenderFns } from "./UnpauseSubscriptionConfirm.vue?vue&type=template&id=25b9220a"
import script from "./UnpauseSubscriptionConfirm.vue?vue&type=script&lang=js"
export * from "./UnpauseSubscriptionConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports